import { isBrowser } from '@jarvis.oddle/core/env'
import { Router } from '@jarvis.oddle/core/tools/routes'

export const redirect = ({ currentRoute, path, locale, as, scroll = true, replace = false, shallow = false } = {}) => {
  if (isBrowser() && scroll) {
    window.scrollTo(0, 0)
  }
  const query = { ...currentRoute, path }
  if (locale) {
    query.locale = locale
  }

  if (replace) {
    Router.replace({ pathname: '/', query }, as, { shallow })
  } else {
    Router.push({ pathname: '/', query }, as, { shallow })
  }
}

export const verifyUrl = ({ url, path }) => {
  const checkDuplicateLocaleCode = (url || '').match(/(\/[a-z]{2}_[A-Z]{2}){2}/g) || []
  // the max length should be 5 because checkout page have longest path with 5
  // shouldn't remove this blocker because it help us block any calling api at UserContext when Shop was accessed with invalid url
  return checkDuplicateLocaleCode.length <= 1 && path.length < 6
}

export const parserHref = (url) => {
  return url.includes('://') ? url : `https://${url}`
}
